import { ExternalProvider, Web3Provider } from '@ethersproject/providers'
import detectEthereumProvider from '@metamask/detect-provider'
import type { MetaMaskInpageProvider } from '@metamask/providers'
import { providers, Signer } from 'ethers'

export class WalletEnable {
  wallet!: MetaMaskInpageProvider
  provider!: Web3Provider
  signer!: Signer

  async init () {
    this.wallet = await detectEthereumProvider() as MetaMaskInpageProvider

    if (this.wallet) {
      this.provider = new Web3Provider(this.wallet as unknown as ExternalProvider)
      this.signer = this.provider.getSigner()

      return this
    } else {
      console.log('Please install MetaMask!')
    }
  }

  async gasFee (
    txParams: providers.TransactionRequest,
    up = 1
  ) {
    const [gasPrice, gasLimit] = await Promise.all([
      this.signer.getGasPrice(),
      this.signer.estimateGas(txParams)])

    return {
      gasPrice,
      gasLimit: gasLimit.mul(up)
    }
  }
}
